import { getAppGlobals } from './utils';

// component to serialize app globals into the HTML
// this should be included in the <head> before <Meta>
export function AppGlobalsScript() {
  const appGlobals = getAppGlobals();
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `window.__AppGlobals__=${JSON.stringify(appGlobals)};`,
      }}
    />
  );
}
